import React, { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';

import { getBasketData, refetchBasketData } from "../queries/global";
import { NotificationContext, handleError } from '../context/NotificationContext';

import * as QUERIES from "../queries/query-functions";
import ArrowRightIcon from '../svg/arrow-right';

const PromoCodeInput = ({buttonText, descriptionText}) => {

    const {notification, setNotification} = useContext(NotificationContext);
    const { data: basketData } = getBasketData();

    const patchBasket = useMutation({
        mutationFn: (patchBody) => QUERIES.patchBasket(patchBody),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: (data) => {
            refetchBasketData();
        },
    });

    const applyPromoCode = (formData) => {
        const code = formData.get("promocode");
        patchBasket.mutateAsync({ PromoCode : code });
    }

  return (
    <section className='booking-pathway__promo-code'>
        <form onSubmit={(e) => {
                e.preventDefault(); // prevent default form submission
                const formData = new FormData(e.target);
                applyPromoCode(formData);
            }}>
            <label className='booking-pathway__header--aside' htmlFor="promoInput">Promo code</label>
            <label className='booking-pathway__label' htmlFor="promoInput">{descriptionText ? descriptionText : 'Have a promo code? Enter it here'}</label>
            <div className='booking-pathway__promo-code--input'>
                <input id="promoInput" type="text" name="promocode" />
                <button className={`btn ${buttonText ? 'btn--primary' : 'btn--purple-neutral100'}`} type="submit" value="Apply">
                    <span className="sr-only">Apply promo code</span>
                    {buttonText ? buttonText : <ArrowRightIcon/>}                    
                </button>
            </div>

            <div role="alert">
                {basketData?.promoCode ?
                    <p className='confirmation-message'>Code ‘{basketData?.promoCode}’ applied.</p>
                :null}
            </div>
        </form>
    </section>
  );
};

export default PromoCodeInput;
